//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Questions',
  props: {
    coin: {
      type: Object,
      default: null
    },
    data: {
      type: Object,
      default: null
    },
    tetherData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      showExpand: {
        1: false,
        2: false,
        3: false,
        4: false
      }
    }
  }
}
